import { render } from "./FooterStartseite.vue?vue&type=template&id=0a3f90ba"
import script from "./FooterStartseite.vue?vue&type=script&lang=ts"
export * from "./FooterStartseite.vue?vue&type=script&lang=ts"

import "./FooterStartseite.vue?vue&type=style&index=0&id=0a3f90ba&lang=scss"
script.render = render

export default script